// @ts-nocheck
import * as types from 'appRedux/actions/payment_act';

const initialState = {
  loader: false,
  paymentActs: [],
  selectedPaymentActId: null,
  form: {
    title: '',
    description: '',
  },
  searchText: '',
  showFormModal: false,
  showConfirmationModal: false,
};

function paymentActReducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.GET_PAYMENT_ACT_REQUEST:
      return {
        ...state,
        loader: true,
      };

    case types.GET_PAYMENT_ACT_SUCCESS:
      return {
        ...state,
        paymentActs: action.payload,
        loader: false,
      };

    case types.ADD_PAYMENT_ACT_SUCCESS:
      return {
        ...state,

        paymentActs: [...state.paymentActs, action.payload],
      };

    case types.GET_PAYMENT_ACT_BY_ID_SUCCESS: {
      return {
        ...state,
        form: {
          title: action.payload.title,
          description: action.payload.description,
        },
      };
    }

    case types.DELETE_PAYMENT_ACT_SUCCESS:
      return {
        ...state,
        paymentActs: state.paymentActs.filter(
          (paymentAct) => paymentAct.id !== action.payload.id,
        ),
      };

    case types.OPEN_FORM_MODAL:
      return {
        ...state,
        showFormModal: true,
      };

    case types.CLOSE_FORM_MODAL:
      return {
        ...state,
        showFormModal: false,
      };

    case types.OPEN_CONFIRMATION_MODAL:
      return {
        ...state,
        showConfirmationModal: true,
        selectedPaymentActId: action.payload.paymentActId,
      };

    case types.CLOSE_CONFIRMATION_MODAL:
      return {
        ...state,
        showConfirmationModal: false,
      };

    case types.UPDATE_FORM_FIELD:
      return updateFormField(state, action);

    case types.RESET_FORM_FIELD:
      return {
        ...state,
        form: {
          title: '',
          description: '',
        },
      };

    case types.UPDATE_SEARCH_TEXT:
      return {
        ...state,
        searchText: action.payload.text,
      };

    default: {
      return state;
    }
  }
}

const updateFormField = (state, action) => {
  const {
    payload: { name, value },
  } = action;
  return {
    ...state,
    form: {
      ...state.form,
      [name]: value,
    },
  };
};
export default paymentActReducer;
